import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import './AdminInfo.scss'
import { companyService } from '../../../services/companyService'

export default function AdminInfo() {
  const [info, setInfo] = useState(null)

  const fetchInfo = async () => {
    const response = await companyService.getAdminInfo()
    if (response.isOk) {
      setInfo(response.data)
    } else {
      toast.error('Greška pri dohvaćanju podataka.')
    }
  }

  useEffect(() => {
    fetchInfo()
  }, [])

  return (
    <div id="admin-info">
      <h1 className="page-title mb-4">Info</h1>

      {info ? (
        <>
          <p>
            <b>Broj korisnika:</b>
            {` ${info.total_users}`}
          </p>
          <p>
            <b>Broj firmi:</b>
            {` ${info.total_companies}`}
          </p>
          <p>
            <b>Broj proizvoda:</b>
            {` ${info.total_products}`}
          </p>
        </>
      ) : (
        <p>Učitavanje...</p>
      )}
    </div>
  )
}
